"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var jsts = __importStar(require("jsts"));
var Geometry_1 = __importDefault(require("./Geometry"));
var GeometryType_1 = require("./GeometryType");
var Validators_1 = __importDefault(require("../shared/Validators"));
var LineString = /** @class */ (function (_super) {
    __extends(LineString, _super);
    function LineString(coordinates) {
        var _this = _super.call(this) || this;
        _this._coordinates = new Array();
        if (!lodash_1.default.isUndefined(coordinates)) {
            coordinates.forEach(function (c) { return _this._coordinates.push(c); });
        }
        return _this;
    }
    Object.defineProperty(LineString.prototype, "type", {
        get: function () {
            return GeometryType_1.GeometryType.LineString;
        },
        enumerable: true,
        configurable: true
    });
    LineString.prototype.coordinatesFlat = function () {
        return this._coordinates;
    };
    LineString.prototype.coordinates = function () {
        return this._coordinates.map(function (c) { return [c.x, c.y]; });
    };
    LineString.prototype._ts = function () {
        return Geometry_1.default._factory.createLineString(this._coordinates.map(function (c) { return new jsts.geom.Coordinate(c.x, c.y); }));
    };
    LineString.prototype._clone = function (convert) {
        var tmpCoordinates = this._coordinates.map(function (c) {
            var tmp = lodash_1.default.clone(c);
            if (convert !== undefined) {
                tmp = convert(tmp);
            }
            return tmp;
        });
        return new LineString(tmpCoordinates);
    };
    LineString.prototype.forEachCoordinates = function (callback) {
        this._coordinates.forEach(callback);
    };
    LineString._from = function (line) {
        return new LineString(line.getCoordinates().map(function (c) { return ({ x: c.x, y: c.y }); }));
    };
    LineString.fromNumbers = function () {
        var coordinates = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            coordinates[_i] = arguments[_i];
        }
        Validators_1.default.validateCoordinateNumbers(coordinates, 4);
        var line = new LineString();
        for (var i = 0; i < coordinates.length - 1; i += 2) {
            line._coordinates.push({ x: coordinates[i], y: coordinates[i + 1] });
        }
        return line;
    };
    LineString.fromPoints = function () {
        var points = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            points[_i] = arguments[_i];
        }
        var line = new LineString();
        for (var _a = 0, points_1 = points; _a < points_1.length; _a++) {
            var p = points_1[_a];
            line._coordinates.push(p);
        }
        return line;
    };
    return LineString;
}(Geometry_1.default));
exports.default = LineString;
